import index from './form-spinbutton'

export default index